module.exports = __webpack_public_path__ + "lazer1.png?fd3ee374ef4cf78010478e2992c4ec78";